import React from "react";
import "./App.scss";
import Main from "./containers/Main";

function App() {
  return (
    <div>
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <Main />
    </div>
  );
}

export default App;
